/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/iframe-has-title */
import React from "react";
import FlexBox from "../../components/Shared/FlexBox";
import styled from "styled-components";
import Container from "../../components/Shared/Container";
import Title from "../../components/Shared/Title";

const PartialMapComponent = () => {
	const PartialIntro = styled(FlexBox)`
      height: max-content;
      padding: 90px 0;
      background-color: #f7f9f7;

      ${Container} {
        justify-content: center;
        align-items: center;
      }

			img {
				&[data-ref=building-1]{
					width: 550px;
					position: absolute;
					bottom: -300px;
					left:-250px;
					transform: scaleX(-1);
					z-index: 0;
				}
				&[data-ref=building-2]{
					width: 700px;
					position: absolute;
					bottom: -290px;
					right:-300px;
					z-index: 0;
				}
      }

      @media (max-width: 767px) {
        padding-top: 60px;
        ${FlexBox} {
        }
				iframe {
					height: 400px;
				}

				img {
					&[data-ref=building-1]{
						width: 250px;
						position: absolute;
						bottom: -150px;
						left:-150px;
						transform: scaleX(-1);
						z-index: 0;
					}
					&[data-ref=building-2]{
						width: 300px;
						position: absolute;
						bottom: -150px;
						right:-150px;
						z-index: 0;
					}
				}
      }
    `;

	return (
		<PartialIntro id="map">
			<Container>
				<Title title="活動地圖" en="SURFING MAP" borderdark />
				<iframe
					src="https://www.google.com/maps/d/embed?mid=1_czJBOqqz5MAzHPQ4EHydOyKFcRk5go&ehbc=2E312F"
					width="100%"
					height="650px"
					frameBorder="0"
					allowfullscreen>
				</iframe>
			</Container>
		</PartialIntro>
	);
}

export default PartialMapComponent;
